/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface IntegrationsService {
  /** @summary List Integrations */
  listIntegrations: {
    /** @summary List Integrations */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<ListIntegrationsSchema, ListIntegrationsParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<ListIntegrationsParameters, TMeta, TSignal> | void),
      client?: (
        schema: ListIntegrationsSchema,
        options: {
          parameters: ListIntegrationsParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListIntegrationsData, ListIntegrationsError>>
    ): Promise<RequestFnResponse<ListIntegrationsData, ListIntegrationsError>>;
    /** @summary List Integrations */
    getQueryKey(
      parameters: DeepReadonly<ListIntegrationsParameters> | void
    ): ServiceOperationQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Integrations
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.integrationsService.listIntegrations.useQuery()
     * ```
     */
    useQuery<TData = ListIntegrationsData>(
      parameters:
        | ServiceOperationQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>
        | (DeepReadonly<ListIntegrationsParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListIntegrationsData,
          ListIntegrationsError,
          TData,
          ServiceOperationQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListIntegrationsError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Integrations
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.integrationsService.listIntegrations.useQuery()
     * ```
     */
    useQuery<TData = ListIntegrationsData>(
      parameters:
        | ServiceOperationQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>
        | (DeepReadonly<ListIntegrationsParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListIntegrationsData,
          ListIntegrationsError,
          TData,
          ServiceOperationQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListIntegrationsError>>;
    /** @summary List Integrations */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListIntegrationsParameters> | void
    ): ServiceOperationInfiniteQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Integrations
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.integrationsService.listIntegrations.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListIntegrationsParameters,
      TQueryFnData = ListIntegrationsData,
      TData = OperationInfiniteData<TQueryFnData, ListIntegrationsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>
        | (DeepReadonly<ListIntegrationsParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListIntegrationsError,
          TData,
          ServiceOperationInfiniteQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListIntegrationsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Integrations
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.integrationsService.listIntegrations.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListIntegrationsParameters,
      TQueryFnData = ListIntegrationsData,
      TData = OperationInfiniteData<TQueryFnData, ListIntegrationsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>
        | (DeepReadonly<ListIntegrationsParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListIntegrationsError,
          TData,
          ServiceOperationInfiniteQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListIntegrationsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListIntegrationsError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List Integrations
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listIntegrationsTotal = qraft.integrationsService.listIntegrations.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListIntegrationsSchema,
            ListIntegrationsData,
            TInfinite,
            ListIntegrationsParameters,
            ListIntegrationsError
          >
        | QueryFiltersByQueryKey<
            ListIntegrationsSchema,
            ListIntegrationsData,
            TInfinite,
            ListIntegrationsParameters,
            ListIntegrationsError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List Integrations
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listIntegrationsResults = qraft.integrationsService.listIntegrations.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listIntegrationsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listIntegrationsCombinedResults = qraft.integrationsService.listIntegrations.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listIntegrationsCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListIntegrationsSchema,
          ListIntegrationsParameters,
          ListIntegrationsData,
          ListIntegrationsError
        >
      >,
      TCombinedResult = Array<UseQueryResult<ListIntegrationsData, ListIntegrationsError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<ListIntegrationsData, ListIntegrationsError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List Integrations
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.integrationsService.listIntegrations.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = ListIntegrationsData>(
      parameters:
        | ServiceOperationQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>
        | (DeepReadonly<ListIntegrationsParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListIntegrationsData,
          ListIntegrationsError,
          TData,
          ServiceOperationQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListIntegrationsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List Integrations
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.integrationsService.listIntegrations.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends ListIntegrationsParameters, TData = ListIntegrationsData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>
        | (DeepReadonly<ListIntegrationsParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListIntegrationsData,
          ListIntegrationsError,
          OperationInfiniteData<TData, ListIntegrationsParameters>,
          ServiceOperationInfiniteQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListIntegrationsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListIntegrationsParameters>,
      OperationError<ListIntegrationsError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List Integrations
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listIntegrationsData = qraft.integrationsService.listIntegrations.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listIntegrationsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listIntegrationsCombinedData = qraft.integrationsService.listIntegrations.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listIntegrationsCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListIntegrationsSchema,
          ListIntegrationsParameters,
          ListIntegrationsData,
          ListIntegrationsError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<ListIntegrationsData, ListIntegrationsError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<ListIntegrationsData, ListIntegrationsError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary List Integrations */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListIntegrationsSchema,
        ListIntegrationsData,
        ListIntegrationsParameters,
        ListIntegrationsError
      > | void
    ): Promise<ListIntegrationsData>;
    /** @summary List Integrations */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListIntegrationsSchema,
        ListIntegrationsData,
        ListIntegrationsParameters,
        ListIntegrationsError
      > | void
    ): Promise<void>;
    /** @summary List Integrations */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListIntegrationsSchema,
        ListIntegrationsData,
        ListIntegrationsParameters,
        ListIntegrationsError
      > | void
    ): Promise<ListIntegrationsData>;
    /** @summary List Integrations */
    fetchInfiniteQuery<TPageParam extends ListIntegrationsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListIntegrationsSchema,
        ListIntegrationsData,
        ListIntegrationsParameters,
        DeepReadonly<TPageParam>,
        ListIntegrationsError
      > | void
    ): Promise<OperationInfiniteData<ListIntegrationsData, ListIntegrationsParameters>>;
    /** @summary List Integrations */
    prefetchInfiniteQuery<TPageParam extends ListIntegrationsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListIntegrationsSchema,
        ListIntegrationsData,
        ListIntegrationsParameters,
        DeepReadonly<TPageParam>,
        ListIntegrationsError
      > | void
    ): Promise<void>;
    /** @summary List Integrations */
    ensureInfiniteQueryData<TPageParam extends ListIntegrationsParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListIntegrationsSchema,
        ListIntegrationsData,
        ListIntegrationsParameters,
        DeepReadonly<TPageParam>,
        ListIntegrationsError
      > | void
    ): Promise<OperationInfiniteData<ListIntegrationsData, ListIntegrationsParameters>>;
    /** @summary List Integrations */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>
        | (DeepReadonly<ListIntegrationsParameters> | void)
    ): ListIntegrationsData | undefined;
    /** @summary List Integrations */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>
        | (DeepReadonly<ListIntegrationsParameters> | void)
    ): OperationInfiniteData<ListIntegrationsData, ListIntegrationsParameters> | undefined;
    /** @summary List Integrations */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListIntegrationsSchema,
            ListIntegrationsData,
            TInfinite,
            ListIntegrationsParameters,
            ListIntegrationsError
          >
        | QueryFiltersByQueryKey<
            ListIntegrationsSchema,
            ListIntegrationsData,
            TInfinite,
            ListIntegrationsParameters,
            ListIntegrationsError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>,
            data: NoInfer<OperationInfiniteData<ListIntegrationsData, ListIntegrationsParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>,
            data: ListIntegrationsData | undefined,
          ]
        >;
    /** @summary List Integrations */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>
        | (DeepReadonly<ListIntegrationsParameters> | void)
    ): QueryState<ListIntegrationsData, ListIntegrationsError> | undefined;
    /** @summary List Integrations */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListIntegrationsParameters>
        | ServiceOperationInfiniteQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>
        | void
    ):
      | QueryState<OperationInfiniteData<ListIntegrationsData, ListIntegrationsParameters>, ListIntegrationsError>
      | undefined;
    /** @summary List Integrations */
    setQueryData(
      parameters:
        | (DeepReadonly<ListIntegrationsParameters> | undefined)
        | ServiceOperationQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>,
      updater: Updater<
        NoInfer<ListIntegrationsData> | undefined,
        NoInfer<DeepReadonly<ListIntegrationsData>> | undefined
      >,
      options?: SetDataOptions
    ): ListIntegrationsData | undefined;
    /** @summary List Integrations */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListIntegrationsParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<ListIntegrationsSchema, ListIntegrationsParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<ListIntegrationsData, ListIntegrationsParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<ListIntegrationsData, ListIntegrationsParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<ListIntegrationsData, ListIntegrationsParameters> | undefined;
    /** @summary List Integrations */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListIntegrationsSchema,
            ListIntegrationsData,
            TInfinite,
            ListIntegrationsParameters,
            ListIntegrationsError
          >
        | QueryFiltersByQueryKey<
            ListIntegrationsSchema,
            ListIntegrationsData,
            TInfinite,
            ListIntegrationsParameters,
            ListIntegrationsError
          >,
      updater: Updater<NoInfer<ListIntegrationsData> | undefined, NoInfer<ListIntegrationsData> | undefined>,
      options?: SetDataOptions
    ): Array<ListIntegrationsData | undefined>;
    /** @summary List Integrations */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListIntegrationsSchema,
        ListIntegrationsData,
        TInfinite,
        ListIntegrationsParameters,
        ListIntegrationsError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary List Integrations */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListIntegrationsSchema,
            ListIntegrationsData,
            TInfinite,
            ListIntegrationsParameters,
            ListIntegrationsError
          >
        | QueryFiltersByQueryKey<
            ListIntegrationsSchema,
            ListIntegrationsData,
            TInfinite,
            ListIntegrationsParameters,
            ListIntegrationsError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary List Integrations */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListIntegrationsSchema,
            ListIntegrationsData,
            TInfinite,
            ListIntegrationsParameters,
            ListIntegrationsError
          >
        | QueryFiltersByQueryKey<
            ListIntegrationsSchema,
            ListIntegrationsData,
            TInfinite,
            ListIntegrationsParameters,
            ListIntegrationsError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary List Integrations */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListIntegrationsSchema,
            ListIntegrationsData,
            TInfinite,
            ListIntegrationsParameters,
            ListIntegrationsError
          >
        | QueryFiltersByQueryKey<
            ListIntegrationsSchema,
            ListIntegrationsData,
            TInfinite,
            ListIntegrationsParameters,
            ListIntegrationsError
          >
    ): void;
    /** @summary List Integrations */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListIntegrationsSchema,
            ListIntegrationsData,
            TInfinite,
            ListIntegrationsParameters,
            ListIntegrationsError
          >
        | QueryFiltersByQueryKey<
            ListIntegrationsSchema,
            ListIntegrationsData,
            TInfinite,
            ListIntegrationsParameters,
            ListIntegrationsError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary List Integrations */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListIntegrationsSchema,
            ListIntegrationsData,
            TInfinite,
            ListIntegrationsParameters,
            ListIntegrationsError
          >
        | QueryFiltersByQueryKey<
            ListIntegrationsSchema,
            ListIntegrationsData,
            TInfinite,
            ListIntegrationsParameters,
            ListIntegrationsError
          >
    ): number;
    schema: ListIntegrationsSchema;
    types: {
      parameters: ListIntegrationsParameters;
      data: ListIntegrationsData;
      error: ListIntegrationsError;
    };
  };
  /** @summary Create Integration */
  createIntegration: {
    /** @summary Create Integration */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CreateIntegrationBody, CreateIntegrationParameters, TMeta, TSignal>,
      client?: (
        schema: CreateIntegrationSchema,
        options: ServiceOperationMutationFnOptions<CreateIntegrationBody, CreateIntegrationParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CreateIntegrationData, CreateIntegrationError>>
    ): Promise<RequestFnResponse<CreateIntegrationData, CreateIntegrationError>>;
    /** @summary Create Integration */
    getMutationKey(
      parameters: DeepReadonly<CreateIntegrationParameters> | void
    ): ServiceOperationMutationKey<CreateIntegrationSchema, CreateIntegrationParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Integration
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.integrationsService.createIntegration.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.integrationsService.createIntegration.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateIntegrationBody, TContext = unknown>(
      parameters: DeepReadonly<CreateIntegrationParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateIntegrationSchema,
        CreateIntegrationData,
        CreateIntegrationParameters,
        TVariables,
        OperationError<CreateIntegrationError>,
        TContext
      >
    ): UseMutationResult<CreateIntegrationData, OperationError<CreateIntegrationError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Integration
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.integrationsService.createIntegration.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.integrationsService.createIntegration.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateIntegrationBody, CreateIntegrationParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateIntegrationSchema,
        CreateIntegrationData,
        CreateIntegrationParameters,
        TVariables,
        OperationError<CreateIntegrationError>,
        TContext
      >
    ): UseMutationResult<CreateIntegrationData, OperationError<CreateIntegrationError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create Integration
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createIntegrationTotal = qraft.integrationsService.createIntegration.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createIntegrationTotal = qraft.integrationsService.createIntegration.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateIntegrationBody,
            CreateIntegrationData,
            CreateIntegrationParameters,
            OperationError<CreateIntegrationError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateIntegrationSchema,
            CreateIntegrationBody,
            CreateIntegrationData,
            CreateIntegrationParameters,
            OperationError<CreateIntegrationError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create Integration
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createIntegrationPendingMutationVariables = qraft.integrationsService.createIntegration.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createIntegrationMutationData = qraft.integrationsService.createIntegration.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateIntegrationData,
        OperationError<CreateIntegrationError>,
        MutationVariables<CreateIntegrationBody, CreateIntegrationParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateIntegrationBody,
            CreateIntegrationData,
            CreateIntegrationParameters,
            OperationError<CreateIntegrationError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateIntegrationSchema,
            CreateIntegrationBody,
            CreateIntegrationData,
            CreateIntegrationParameters,
            OperationError<CreateIntegrationError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateIntegrationData,
          OperationError<CreateIntegrationError>,
          MutationVariables<CreateIntegrationBody, CreateIntegrationParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create Integration */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateIntegrationBody,
            CreateIntegrationData,
            CreateIntegrationParameters,
            OperationError<CreateIntegrationError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateIntegrationSchema,
            CreateIntegrationBody,
            CreateIntegrationData,
            CreateIntegrationParameters,
            OperationError<CreateIntegrationError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create Integration
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.integrationsService.createIntegration.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.integrationsService.createIntegration.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateIntegrationBody,
              CreateIntegrationData,
              CreateIntegrationParameters,
              OperationError<CreateIntegrationError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateIntegrationSchema,
              CreateIntegrationBody,
              CreateIntegrationData,
              CreateIntegrationParameters,
              OperationError<CreateIntegrationError>,
              TContext
            >
      ):
        | Mutation<
            CreateIntegrationData,
            CreateIntegrationError,
            MutationVariables<CreateIntegrationBody, CreateIntegrationParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateIntegrationBody,
              CreateIntegrationData,
              CreateIntegrationParameters,
              OperationError<CreateIntegrationError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateIntegrationSchema,
              CreateIntegrationBody,
              CreateIntegrationData,
              CreateIntegrationParameters,
              OperationError<CreateIntegrationError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateIntegrationData,
          CreateIntegrationError,
          MutationVariables<CreateIntegrationBody, CreateIntegrationParameters>,
          TContext
        >
      >;
    };
    schema: CreateIntegrationSchema;
    types: {
      parameters: CreateIntegrationParameters;
      data: CreateIntegrationData;
      error: CreateIntegrationError;
      body: CreateIntegrationBody;
    };
  };
  /** @summary Update Integration */
  updateIntegration: {
    /** @summary Update Integration */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<UpdateIntegrationBody, UpdateIntegrationParameters, TMeta, TSignal>,
      client?: (
        schema: UpdateIntegrationSchema,
        options: ServiceOperationMutationFnOptions<UpdateIntegrationBody, UpdateIntegrationParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<UpdateIntegrationData, UpdateIntegrationError>>
    ): Promise<RequestFnResponse<UpdateIntegrationData, UpdateIntegrationError>>;
    /** @summary Update Integration */
    getMutationKey(
      parameters: DeepReadonly<UpdateIntegrationParameters> | void
    ): ServiceOperationMutationKey<UpdateIntegrationSchema, UpdateIntegrationParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update Integration
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.integrationsService.updateIntegration.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.integrationsService.updateIntegration.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends UpdateIntegrationBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateIntegrationParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateIntegrationSchema,
        UpdateIntegrationData,
        UpdateIntegrationParameters,
        TVariables,
        OperationError<UpdateIntegrationError>,
        TContext
      >
    ): UseMutationResult<UpdateIntegrationData, OperationError<UpdateIntegrationError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update Integration
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.integrationsService.updateIntegration.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.integrationsService.updateIntegration.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<UpdateIntegrationBody, UpdateIntegrationParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateIntegrationSchema,
        UpdateIntegrationData,
        UpdateIntegrationParameters,
        TVariables,
        OperationError<UpdateIntegrationError>,
        TContext
      >
    ): UseMutationResult<UpdateIntegrationData, OperationError<UpdateIntegrationError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update Integration
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateIntegrationTotal = qraft.integrationsService.updateIntegration.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateIntegrationTotal = qraft.integrationsService.updateIntegration.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateIntegrationBody,
            UpdateIntegrationData,
            UpdateIntegrationParameters,
            OperationError<UpdateIntegrationError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateIntegrationSchema,
            UpdateIntegrationBody,
            UpdateIntegrationData,
            UpdateIntegrationParameters,
            OperationError<UpdateIntegrationError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update Integration
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateIntegrationPendingMutationVariables = qraft.integrationsService.updateIntegration.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateIntegrationMutationData = qraft.integrationsService.updateIntegration.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateIntegrationData,
        OperationError<UpdateIntegrationError>,
        MutationVariables<UpdateIntegrationBody, UpdateIntegrationParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateIntegrationBody,
            UpdateIntegrationData,
            UpdateIntegrationParameters,
            OperationError<UpdateIntegrationError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateIntegrationSchema,
            UpdateIntegrationBody,
            UpdateIntegrationData,
            UpdateIntegrationParameters,
            OperationError<UpdateIntegrationError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateIntegrationData,
          OperationError<UpdateIntegrationError>,
          MutationVariables<UpdateIntegrationBody, UpdateIntegrationParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update Integration */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateIntegrationBody,
            UpdateIntegrationData,
            UpdateIntegrationParameters,
            OperationError<UpdateIntegrationError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateIntegrationSchema,
            UpdateIntegrationBody,
            UpdateIntegrationData,
            UpdateIntegrationParameters,
            OperationError<UpdateIntegrationError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update Integration
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.integrationsService.updateIntegration.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.integrationsService.updateIntegration.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateIntegrationBody,
              UpdateIntegrationData,
              UpdateIntegrationParameters,
              OperationError<UpdateIntegrationError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateIntegrationSchema,
              UpdateIntegrationBody,
              UpdateIntegrationData,
              UpdateIntegrationParameters,
              OperationError<UpdateIntegrationError>,
              TContext
            >
      ):
        | Mutation<
            UpdateIntegrationData,
            UpdateIntegrationError,
            MutationVariables<UpdateIntegrationBody, UpdateIntegrationParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateIntegrationBody,
              UpdateIntegrationData,
              UpdateIntegrationParameters,
              OperationError<UpdateIntegrationError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateIntegrationSchema,
              UpdateIntegrationBody,
              UpdateIntegrationData,
              UpdateIntegrationParameters,
              OperationError<UpdateIntegrationError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateIntegrationData,
          UpdateIntegrationError,
          MutationVariables<UpdateIntegrationBody, UpdateIntegrationParameters>,
          TContext
        >
      >;
    };
    schema: UpdateIntegrationSchema;
    types: {
      parameters: UpdateIntegrationParameters;
      data: UpdateIntegrationData;
      error: UpdateIntegrationError;
      body: UpdateIntegrationBody;
    };
  };
}
/** @summary List Integrations */
export const listIntegrations = {
  schema: {
    method: 'get',
    url: '/integrations/',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListIntegrationsSchema;
  [QraftServiceOperationsToken]: IntegrationsService['listIntegrations'];
};
/** @summary Create Integration */
export const createIntegration = {
  schema: {
    method: 'post',
    url: '/integrations/',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateIntegrationSchema;
  [QraftServiceOperationsToken]: IntegrationsService['createIntegration'];
};
/** @summary Update Integration */
export const updateIntegration = {
  schema: {
    method: 'patch',
    url: '/integrations/update',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateIntegrationSchema;
  [QraftServiceOperationsToken]: IntegrationsService['updateIntegration'];
};
export const integrationsService = {
  listIntegrations,
  createIntegration,
  updateIntegration,
} as const;
type ListIntegrationsSchema = {
  method: 'get';
  url: '/integrations/';
  security: ['HTTPBearer'];
};
type ListIntegrationsParameters = undefined;
type ListIntegrationsData = paths['/integrations/']['get']['responses']['200']['content']['application/json'];
type ListIntegrationsError = unknown;
type CreateIntegrationSchema = {
  method: 'post';
  url: '/integrations/';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateIntegrationParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateIntegrationData = paths['/integrations/']['post']['responses']['201']['content']['application/json'];
type CreateIntegrationError = paths['/integrations/']['post']['responses']['422']['content']['application/json'];
type CreateIntegrationBody = paths['/integrations/']['post']['requestBody']['content']['application/json'];
type UpdateIntegrationSchema = {
  method: 'patch';
  url: '/integrations/update';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateIntegrationParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type UpdateIntegrationData = paths['/integrations/update']['patch']['responses']['200']['content']['application/json'];
type UpdateIntegrationError = paths['/integrations/update']['patch']['responses']['422']['content']['application/json'];
type UpdateIntegrationBody = paths['/integrations/update']['patch']['requestBody']['content']['application/json'];
